import {Button} from '@chekinapp/ui';
import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Link, Navigate, useParams} from 'react-router-dom';
import {IV_DOCUMENT_IMAGE_TYPES} from '@chekin/core';
import {PATHS} from 'routes/constants';
import {
  useFetchIVLottie,
  ANALYTIC_EVENTS,
  Analytics,
  getDocumentType,
  useIVStore,
} from '@chekin/shared';
import {getHelperTextKey} from 'pages/IdentityVerification/utils';
import {BottomBlock, StyledLottieIVDocumentsAnimations, Text, Wrapper} from './styled';
import {ModalTwoButtonsWrapper} from '@guestapp/old-ui-kit';

const ParamTypes = Object.values(IV_DOCUMENT_IMAGE_TYPES);

function UploadingTypeView() {
  const {t} = useTranslation('identity-verification');
  const {type} = useParams<{type: IV_DOCUMENT_IMAGE_TYPES; intentId: string}>();
  const documentType = useIVStore(getDocumentType);
  const {animationData: ivLottieAnimation} = useFetchIVLottie({type});

  const Message = React.useMemo(() => {
    const textKey = getHelperTextKey(type, documentType?.two_sides);

    if (!textKey) {
      return null;
    }

    return <Trans i18nKey={textKey} />;
  }, [documentType?.two_sides, type]);

  if (!type || !ParamTypes.includes(type)) {
    return <Navigate to={IV_DOCUMENT_IMAGE_TYPES.front} />;
  }

  return (
    <Wrapper className="iv-upload-type-view">
      {Boolean(Message) && <Text className="iv-upload-type-view__text">{Message}</Text>}
      <StyledLottieIVDocumentsAnimations loop animationData={ivLottieAnimation} />
      <BottomBlock className="iv-upload-type-view__bottom">
        <ModalTwoButtonsWrapper className="iv-upload-type-view__buttons">
          <Link to={`../${PATHS.verification?.[type]}/take`}>
            <Button
              onClick={() => {
                Analytics.track(ANALYTIC_EVENTS.ivTakingPhoto, {side: type});
              }}
              variant="outline"
            >
              {t('take_a_photo')}
            </Button>
          </Link>
          <Link to={`../${PATHS.verification?.[type]}/upload`}>
            <Button
              onClick={() => {
                Analytics.track(ANALYTIC_EVENTS.ivUploadingPhoto, {side: type});
              }}
              variant="outline"
            >
              {t('upload_file')}
            </Button>
          </Link>
        </ModalTwoButtonsWrapper>
      </BottomBlock>
    </Wrapper>
  );
}

export {UploadingTypeView};
